import { ClientManagementButtonSave } from './ButtonSave';

export const ButtonSave = ClientManagementButtonSave;
